<nb-card class="main-card">
  <nb-card-header> <nb-icon icon="code"></nb-icon> TIP DISTRIBUTION</nb-card-header>
  <nb-card-body>
    <div class="no-data text-center" *ngIf="!turnList?.length"><h6>No pending turns found.</h6></div>
    <div class="row" *ngIf="turnList?.length">
      <div class="col-12">
        <div class="total-tip-wrapper">
          Total tip:
          <input
            #amtInput
            type="text"
            appCurrencyInput
            nbInput
            [(ngModel)]="totalTipAmt"
            (ngModelChange)="onTotalTipAmtChanged()"
          />
        </div>
        <div class="round-checkbox">
          <nb-checkbox [(ngModel)]="inCash" (ngModelChange)="onRoundToOneChanged()"> In cash</nb-checkbox>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="list-wrapper">
          <ng-container *ngFor="let e of turnList">
            <div
              class="list-item-wrapper"
              [class.list-item-wrapper-selected]="e.optionalData?.selected"
              (click)="onItemClick(e)"
            >
              <div class="item-selected">
                <nb-icon *ngIf="e.optionalData.selected" icon="checkmark-square-2" status="primary"></nb-icon>
                <nb-icon *ngIf="!e.optionalData.selected" icon="square" status="basic"></nb-icon>
              </div>
              <div class="item-avatar">
                <app-avatar [avatarUrl]="e.optionalData.employee?.avatarUrl"></app-avatar>
              </div>
              <div class="item-info-1">
                <div>{{ e.optionalData.employee?.firstName }}</div>
                <div class="item-turn-amt"><label>Turn amt:</label>{{ e.amt }}</div>
              </div>
              <div class="item-info-2">
                <div *ngIf="e.optionalData.selected">
                  <label>Tip:</label><strong>{{ e.tip }}</strong>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      [disabled]="!(totalSeparated || (inCash && selectedCount))"
      nbButton
      (click)="onOk()"
      status="{{ inCash ? 'primary' : 'success' }}"
    >
      {{ inCash ? 'MARK TURNS DONE' : 'UPDATE TIPS' }}
    </button>
    <button nbButton class="right-button" (click)="onCancel()"><nb-icon icon="close-outline"></nb-icon>CANCEL</button>
  </nb-card-footer>
</nb-card>
